<div class="header-container">
    <h5 class="mb-0">{{ 'general.audio' | translate }}</h5>
</div>
<div class="audio-container">

    <div class="master-container">
      <div class="form-slider-container form-floating w-100">
        <i class="bi bi-chevron-left slider-button-icon"
          (click)="onSliderMasterDecrease()">
        </i>
        <input type="range" class="form-range w-9"
              [min]="volumeLimitMin" [max]="volumeLimitMax" step="1"
              id="masterVolume"
              [(ngModel)]="audioMasterVolume"
              (change)="this.onSettingMasterChanged($event)">
        <i class="bi bi-chevron-right slider-button-icon"
          (click)="onSliderMasterIncrease()">
        </i>
        <i class="mode-button-icon"
          [ngClass]="audioMasterMode === 0? 'bi bi-volume-mute':'bi bi-volume-up'"
          [title]="this.getAudioModeString(audioMasterMode) | translate" 
          webTooltip data-bs-trigger="hover" data-bs-placement="bottom"
          (click)="onMasterModeToggle()">
        </i>
        <label for="masterVolume">
          {{ ('producer.audioMaster' | translate) + ': ' + audioMasterVolume + ' dB' }}
        </label>
      </div>
    </div>

    <div class="input-list-container w-100">

      <div class="form-default-container form-floating w-100">
        <div class="d-flex flex-column align-items-start justify-content-start">
          <label for="inputDefault">
            {{ ('producer.liveInputDefaultMode' | translate) }}
            <i class="bi bi-info-circle-fill" [title]="'producer.audioDefaultModeTooltip' | translate" webTooltip data-bs-trigger="hover" data-bs-placement="bottom"></i>
          </label>
          <small>{{ this.getAudioModeString(liveInputDefault) | translate }}</small>
        </div>
        <i class="mode-button-icon" [ngClass]="liveInputDefault === 0? 'bi bi-volume-mute': liveInputDefault === 1? 'bi bi-volume-up':'bi bi-volume-up-fill'"
            [title]="this.getAudioModeString(liveInputDefault) | translate" 
            webTooltip data-bs-trigger="hover" data-bs-placement="bottom"
          (click)="onInputModeDefaultToggle()">
        </i>
      </div>

      <div *ngFor="let item of this.audioInputs; let i=index" class="form-slider-container form-floating w-100">
        <i class="bi bi-chevron-left slider-button-icon"
          (click)="onSliderVolumeDecrease(item)">
        </i>
        <input type="range" class="form-range w-9"
              [min]="volumeLimitMin" [max]="volumeLimitMax" step="1"
              [id]="'volume' + i"
              [(ngModel)]="item.settings.volume"
              (change)="this.onSettingInputChanged($event, item)">
        <i class="bi bi-chevron-right slider-button-icon"
          (click)="onSliderVolumeIncrease(item)">
        </i>
        <i class="mode-button-icon" [ngClass]="item.settings.mode === 0? 'bi bi-volume-mute': item.settings.mode === 1? 'bi bi-volume-up':'bi bi-volume-up-fill'"
            [title]="this.getAudioModeString(item.settings.mode) | translate" 
            webTooltip data-bs-trigger="hover" data-bs-placement="bottom"
          (click)="onInputModeToggle(item)">
        </i>
        <label [for]="'volume' + i" [ngClass]="item.playingState === 2? 'text-primary':''">
          <i *ngIf="item.playingState === 2" class="bi bi-circle-fill text-success"></i>
          <i *ngIf="item.playingState !== 2 && item.liveSourceType !== 1" class="bi bi-circle-fill text-danger"></i>
          <i *ngIf="item.playingState !== 2 && item.liveSourceType === 1" class="bi bi-circle text-medium"></i>
  
          <!--<i [ngClass]="item.playingState === 2? 'bi bi-circle-fill text-success':'bi bi-circle text-medium'"></i>-->
          {{ ('producer.audioInput' | translate) + ' #' + (item.id + 1) + ' (' + item.name + '): ' + item.settings.volume + ' dB' }}
        </label>
      </div>
  
    </div>

</div>